import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function LoadingPanel(props) {
    if (props.isLoading) {
        return (
            <div className={`loading-panel`} data-cy="loading-panel">
                <CircularProgress color="primary" style={{ display: 'block', textAlign: 'center', top: "45%", marginLeft: "-10px", left: "50%", position: "absolute", zIndex: "9999" }} />
                <div className="loading-blur-panel" data-cy="loading-panel"></div>
            </div>
        );
    }
    return null;
}